import React from 'react';
import {
    Box,
    Container,
    Heading,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Icon,
    Text,
    VStack
} from '@chakra-ui/react';
// import { FaHome } from 'react-icons/fa';
import { Parallax } from 'react-parallax';
import PageHero2 from '../../assets/PageHero2.webp'
import { useNavigate } from 'react-router-dom';


function InnerPageHero({ title, breadcrumbs }) {
  const navigate = useNavigate();

    return (
        <Parallax
            blur={{ min: -15, max: 15 }}
            bgImage={PageHero2}
            strength={-300}
            bgImageStyle={{ objectFit: 'cover' }}
        >
            <Box
                id="page-hero"
                display="flex"
                alignItems="center"
                justifyContent="center"
                minH="250px"
                position="relative"
                // bgImage={PageHero2}
                // bgSize="cover"
                bgPosition="center"
                color="white"
            >
                {/* Overlay color */}
                <Box
                    position="absolute"
                    top="0"
                    left="0"
                    w="100%"
                    h="100%"
                    bg={"customDarkBlue.900"}
                    opacity={0.8}
                    zIndex="0"
                />

                <Container position="relative" zIndex="1">
                    <VStack spacing={4}>
                        <Heading as="h1" size="xl" maxWidth={'100%'} textAlign="center" px={4} py={2} fontWeight="bold">
                            {title}
                        </Heading>

                        <Breadcrumb
                            separator="›"
                            fontWeight="medium"
                            fontSize="md"
                            justify="center"
                            display="flex"
                            alignItems="center"
                            // border="1px solid"
                            p={2}
                            // margin={"auto"}
                            borderRadius="md"
                            paddingLeft={0}
                        >
                            {breadcrumbs.map((crumb, index) => (
                                <BreadcrumbItem key={index} isCurrentPage={crumb.isCurrentPage}>
                                    {crumb.href ? (
                                        <BreadcrumbLink
                                           onClick={() => !crumb.isCurrentPage && navigate(crumb.href)}
                                            display="inline-flex"
                                            alignItems="center"
                                        >
                                            {crumb.icon && <Icon as={crumb.icon} mr={1} boxSize={4} />}
                                            {crumb.label}
                                        </BreadcrumbLink>
                                    ) : (
                                        <Text as="span">{crumb.label}</Text>
                                    )}
                                </BreadcrumbItem>
                            ))}
                        </Breadcrumb>

                    </VStack>
                </Container>
            </Box>
        </Parallax>
    );
}

export default InnerPageHero;
